export default {
  default_browser_tag: 'FoodAmigos - Comandă online',
  seo: {
    title: '{{name}} - comandă mâncare online în {{city}}',
    description: '{{name}} în {{city}}. Meniu oficial. Economisește și comandă online.',
  },
};
